import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type SidebarHeaderProps = ComponentPropsWithoutRef<'header'>;

export const SidebarHeader = memo(({ className, ...restOfProps }: SidebarHeaderProps) => {
  return (
    <header
      className={cn('mx-2 flex h-16 items-center justify-between gap-2 border-b border-b-gray-5 p-2', className)}
      data-testid="SIDEBAR_HEADER"
      {...restOfProps}
    />
  );
});

SidebarHeader.displayName = 'SidebarHeader';
